/**
 * Azure Entra ID Authentication Configuration
 */

import logger from '../utils/logger';

const readRequiredEnv = (name, testFallback) => {
    const value = process.env[name];
    if (value) return value;

    if (process.env.NODE_ENV === 'test') {
        return testFallback;
    }

    throw new Error(`Missing required environment variable: ${name}`);
};

const clientId = readRequiredEnv('REACT_APP_AZURE_CLIENT_ID', 'test-client-id');
const authority = readRequiredEnv(
    'REACT_APP_AZURE_AUTHORITY',
    'https://test.ciamlogin.com/test.onmicrosoft.com'
);
const knownAuthority = readRequiredEnv('REACT_APP_AZURE_KNOWN_AUTHORITY', 'test.ciamlogin.com');

export const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri: window.location.origin,
        knownAuthorities: [knownAuthority],
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                if (level === 0) logger.error(message);
                else if (level === 1) logger.warn(message);
                else if (level === 2) logger.info(message);
                else logger.debug(message);
            },
        },
    },
};

export const loginRequest = {
    scopes: process.env.REACT_APP_AZURE_SCOPES
        ? process.env.REACT_APP_AZURE_SCOPES.split(',')
        : [`${clientId}/.default`],
};

export const apiConfig = {
    uri: process.env.REACT_APP_API_URL || 'http://localhost:8000',
};
